const headerLink = [
    {
        title : 'Radar',
        to : 'https://radar.arvancloud.ir/'
    },
    {
        title : 'Service Status',
        to : 'https://www.arvancloudstatus.ir/'
    },
    {
        title : 'About Us',
        to : 'https://www.arvancloud.ir/fa/about'
    }
]

export default headerLink